export const payWithCard = {
  currency: 'USD',
  description: 'Secure payment processed through Stripe',
  key: 'credit_card',
  name: 'Pay by Credit Card',
};

export const payWithCompletes = {
  currency: 'completes',
  currencySingular: 'complete',
  key: 'subscription',
  name: 'Use Your Plan',
};

export const payWithCredits = {
  currency: 'credits',
  currencySingular: 'credit',
  description: 'Available Credits:',
  key: 'credits',
  name: 'Spend Numerator Credits',
};
